<template>
    <div>
        <el-row class="tac explainTac">
            <el-col :span="12" style="width:230px;margin-left:1px;">
                <el-menu
                :unique-opened="true"
                :default-active="String(articleID)"
                class="el-menu-vertical-demo"
                @open="handleOpen"
                @close="handleClose">
                    <div v-for="item in navList" :key="item.id">
                        <el-submenu  v-if="item.child" :index="item.name" >
                            <template slot="title">
                                <span>{{item.name}}</span>
                            </template>
                            <el-menu-item-group>
                                <el-menu-item v-for="itemSub in item.child" :index="String(itemSub.id)" :key="itemSub.id" class="subItem" @click="gotoDetail(itemSub.id)">
                                    <span>{{itemSub.name}}</span>
                                </el-menu-item>
                            </el-menu-item-group>
                        </el-submenu>
                        <el-menu-item v-else :index="String(item.id)">
                            <span>{{item.name}}</span>
                        </el-menu-item>
                    </div>
                </el-menu>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { ArticleService } from '../../service/article.service'

  export default {
    data() {
        return {
            navList: []
        }
    },
    computed: {
        articleID() {
            return this.$route.query.id
        }
    },
    methods: {
      handleOpen(key, keyPath) {
        console.log(key, keyPath);
      },
      async getList() {
          const data = await ArticleService.getList()
          this.navList = JSON.parse(JSON.stringify(data))
          this.gotoDetail(data[0].child[0].id)
      },
      handleClose(key, keyPath) {
        console.log(key, keyPath);
      },
      gotoDetail(id) {
          this.$router.push(`/explain/detail/${id}`)
          this.$cookies.set('id',id)
      }
    },
    created() {
        this.getList()
    }
  }
</script>

<style lang="scss">
    .explainTac{
        .el-menu{
            border-right: 0;
        }
        .el-submenu.is-active.is-opened{
            background: #f3f3f3;
        }
        .el-submenu.is-opened{
            .el-submenu__title{
                border-bottom: 1px solid #ddd;
                border-color: #ddd!important;
            }
        }
        .el-submenu,.el-menu-item:not(.subItem){
            padding: 0;
            font-size: 15px;
            border: 1px solid #ddd;
            margin-bottom: 8px;
        }
        .el-menu-item-group__title{
            padding: 0;
        }
        .el-submenu__title{
            font-size: 13px;
            height: 35px;
            line-height: 35px;
        }
        .el-submenu .el-menu-item{
            font-size: 13px;
            height: 35px;
            line-height: 35px;
        }
        .el-submenu__title:hover{
            background: transparent;
        }
        .el-submenu__icon-arrow{
            right: 20px;
        }
        .el-submenu>.el-submenu__title .el-submenu__icon-arrow{
            transform:rotateZ(270deg);
        }
        .el-submenu.is-opened>.el-submenu__title .el-submenu__icon-arrow{
            transform:rotateZ(360deg);
        }
        
    }
</style>

<style scoped>
    
</style>